module.exports = __webpack_public_path__ + "static/assets/a423bd95ee6fce3c914dca3a999c109e.gif";